import React from 'react';
import { Switch, Tooltip } from 'antd';
import { hasPermission } from 'utils/authService';

const AuthorisedSwitch = ({ tooltipTitle = "No access to change.", permission, ...rest }) => {
    return (!hasPermission(permission)) ? <Tooltip title={tooltipTitle}><Switch {...rest} disabled /></Tooltip> : <Switch {...rest} />;
}

// authorised switch to check for all product level access
export const AuthorisedSwitchProductAccess = ({ tooltipTitle = "No access to change.", permission, allProductAccess, ...rest }) => {
    return !(hasPermission(permission) && allProductAccess) ? <Tooltip title={tooltipTitle}><Switch {...rest} disabled /></Tooltip> : <Switch {...rest} />;
}

export default AuthorisedSwitch;